const OPEN_SITE_TARGET = 'open_site_target';

export function openSite(): ThunkAction<void> {
	return (dispatch, getState) => {
		const hostname = getState().configEditor.assets.hostname;
		if (hostname) {
			window.open(`https://${hostname}/logout`, OPEN_SITE_TARGET);
		}
	};
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/config-editor/user.ts